<div [ngSwitch]="currentView">

  <app-login-credentials *ngSwitchCase="'login'"
    [lastUrl]="lastUrl"
    (forgotPassword)="currentView = 'forgotPassword'"
    (mustChangePwd)="currentView = 'changePassword'">
  </app-login-credentials>

  <app-forgot-password *ngSwitchCase="'forgotPassword'"
    (cancel)="currentView = 'login'">
  </app-forgot-password>

  <app-change-password *ngSwitchCase="'changePassword'"
    (cancel)="currentView = 'login'"
    (changed)="currentView = 'login'">
  </app-change-password>

  <app-reset-password *ngSwitchCase="'resetPassword'"
    [token]="resetToken"
    [mode]="resetMode"
    (cancel)="resetPasswordDone()"
    (done)="resetPasswordDone()"
    (expired)="resetPasswordExpired()">
  </app-reset-password>

  <app-expired-token *ngSwitchCase="'expiredToken'"
    (done)="resetPasswordDone()">
  </app-expired-token>

</div>
